/**
 * [#e03fdbc2] Публичные страницы и их языки. Единственное место, где задан язык без
 * префикса: поменять язык главной `/` = поменять DEFAULT_PUBLIC_LOCALE
 * (и `DEFAULT` в public/lp-boot.js, и список в PUBLIC_LOCALE_PATTERN).
 */
export const SITE_URL = 'https://app.mdm.dwish.uz';
export const SITE_NAME = 'DWISH MDM';
export const PUBLIC_LOCALES = ['en', 'ru', 'uz', 'es'] as const;
export type PublicLocale = (typeof PUBLIC_LOCALES)[number];
export const DEFAULT_PUBLIC_LOCALE: PublicLocale = 'en';
/** Языки с префиксом в адресе, для маршрутов vue-router. */
export const PUBLIC_LOCALE_PATTERN = 'ru|uz|es';

/** Связь с нами в Telegram. */
export const TELEGRAM_URL = 'https://t.me/dwish_support';
export const TELEGRAM_HANDLE = '@dwish_support';

export function isPublicLocale(v: unknown): v is PublicLocale {
  return typeof v === 'string' && (PUBLIC_LOCALES as readonly string[]).includes(v);
}

/** `/articles` + `ru` → `/ru/articles`; `/` + `ru` → `/ru/`; язык по умолчанию без префикса. */
export function localizedPath(path: string, locale: PublicLocale): string {
  if (locale === DEFAULT_PUBLIC_LOCALE) return path;
  return path === '/' ? `/${locale}/` : `/${locale}${path}`;
}

/** Адрес без языкового префикса и его язык. */
export function splitLocale(pathname: string): { locale: PublicLocale; path: string } {
  const m = pathname.match(new RegExp(`^/(${PUBLIC_LOCALE_PATTERN})(/.*)?$`));
  if (!m) return { locale: DEFAULT_PUBLIC_LOCALE, path: pathname || '/' };
  return { locale: m[1] as PublicLocale, path: m[2] && m[2] !== '/' ? m[2] : '/' };
}
